import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import AppointmentsClientWithSettings from '../components/appointments/AppointmentsClientWithSettings';

export default function AppointmentsPage() {
  const { t } = useTranslation(['appointments', 'common']);
  
  return (
    <>
      <Helmet>
        <title>{t('title')} - {t('common:appName')}</title>
        <meta name="description" content={t('subtitle')} />
      </Helmet>
      
      <AppointmentsClientWithSettings />
    </>
  );
}
